import { createContext, useEffect, useReducer } from "react";
import type { FC, ReactNode } from "react";
import PropTypes from "prop-types";
import type { User, UserAuthenticate } from "../types/user";
import { authApi } from "../__fakeApi__/authApi";
import authService from "../UIS_services/AuthenticationService/authService";
import menuService from "src/UIS_services/AuthenticationService/menuService";
import sha256 from 'crypto-js/sha256';
import hmacSHA512 from 'crypto-js/hmac-sha512';
import Base64 from 'crypto-js/enc-base64';
import CryptoJS from 'crypto-js';
import toast from "react-hot-toast";
const PrivateKey = "pscRBF0zT2Mqo6vMw69YMOH43IrB2RtXBS0EHit2kzvL2auxaFJBvw";

interface State {
    isInitialized: boolean;
    isAuthenticated: boolean;
    user: User | null;
    authmenu: any;
}

interface AuthContextValue extends State {
    platform: "JWT";
    login: (email: string, password: string) => Promise<void>;
    logout: () => Promise<void>;
    register: (email: string, name: string, password: string) => Promise<void>;
    loginAdfs: (email: string) => Promise<void>;
    authmenu: null;
}

interface AuthProviderProps {
    children: ReactNode;
}

type InitializeAction = {
    type: "INITIALIZE";
    payload: {
        isAuthenticated: boolean;
        user: User | null;
        authmenu: any | null;
    };
};

type LoginAction = {
    type: "LOGIN";
    payload: {
        user: User;
        authmenu: any;
    };
};
type LoginActionADFS = {
    type: "LOGINADFS";
    payload: {
        user: User;
        authmenu: any;
    };
};

type LogoutAction = {
    type: "LOGOUT";
};

type RegisterAction = {
    type: "REGISTER";
    payload: {
        user: User;
    };
};

type Action = InitializeAction | LoginAction | LogoutAction | RegisterAction | LoginActionADFS;

const initialState: State = {
    isAuthenticated: false,
    isInitialized: false,
    user: null,
    authmenu: null,
};

const handlers: Record<string, (state: State, action: Action) => State> = {
    INITIALIZE: (state: State, action: InitializeAction): State => {
        const { isAuthenticated, user, authmenu } = action.payload;

        return {
            ...state,
            isAuthenticated,
            isInitialized: true,
            user,
            authmenu,
        };
    },
    LOGIN: (state: State, action: LoginAction): State => {
        const { user, authmenu } = action.payload;

        return {
            ...state,
            isAuthenticated: true,
            user,
            authmenu,
        };
    },
    LOGINADFS: (state: State, action: LoginActionADFS): State => {
        const { user, authmenu } = action.payload;
        return {
            ...state,
            isAuthenticated: true,
            user,
            authmenu,
        };
    },
    LOGOUT: (state: State): State => ({
        ...state,
        isAuthenticated: false,
        user: null,
    }),
    REGISTER: (state: State, action: RegisterAction): State => {
        const { user } = action.payload;

        return {
            ...state,
            isAuthenticated: true,
            user,
        };
    },
};

const reducer = (state: State, action: Action): State =>
    handlers[action.type] ? handlers[action.type](state, action) : state;

const AuthContext = createContext<AuthContextValue>({
    ...initialState,
    platform: "JWT",
    login: () => Promise.resolve(),
    logout: () => Promise.resolve(),
    loginAdfs: () => Promise.resolve(),
    register: () => Promise.resolve(),
});

export const AuthProvider: FC<AuthProviderProps> = (props) => {
    const { children } = props;
    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        const initialize = async (): Promise<void> => {
            try {
                //  debugger;
                let authorizationData =
                    localStorage.getItem("authorizationData");
                let AuthMenu =
                    localStorage.getItem("AuthMenu");
                if (authorizationData) {
                    const user = JSON.parse(authorizationData);
                    // let datadecrypt = decrypt(AuthMenu);
                    // const authmenu = AuthMenu;//JSON.parse(datadecrypt);
                    const authmenu = await apiMenu();
                    dispatch({
                        type: "INITIALIZE",
                        payload: {
                            isAuthenticated: true,
                            user,
                            authmenu,
                        },
                    });
                } else {
                    dispatch({
                        type: "INITIALIZE",
                        payload: {
                            isAuthenticated: false,
                            user: null,
                            authmenu: null,
                        },
                    });
                }
            } catch (err) {
                console.error(err);
                dispatch({
                    type: "INITIALIZE",
                    payload: {
                        isAuthenticated: false,
                        user: null,
                        authmenu: null,
                    },
                });
            }
        };

        initialize();
    }, []);

    const login = async (email: string, password: string): Promise<void> => {
        let UserAuth: UserAuthenticate = {
            username: email,
            password: password,
        };
        const user = await authService.GetUser(UserAuth);
        localStorage.setItem("authorizationData", JSON.stringify(user));
        const authmenu = await apiMenu();
        dispatch({
            type: "LOGIN",
            payload: {
                user,
                authmenu,
            },
        });
    };

    const loginAdfs = async (email: string): Promise<void> => {
        let UserAuthenticate = {
            Token: email,
        };
        try {
            const user = await authService.AuthenSSO(UserAuthenticate);
            localStorage.setItem("authorizationData", JSON.stringify(user));
            const authmenu = await apiMenu();
            dispatch({
                type: "LOGIN",
                payload: {
                    user,
                    authmenu,
                },
            });

        } catch (err) {
            toast.error(err.response.data.message)
            localStorage.removeItem("authorizationData");
            setTimeout(() => {
                // window.location.href = 'https://sso6.neu.edu.vn/adfs/oauth2/logout?post_logout_redirect_uri=http%3A%2F%2Flocalhost%3A3000'
                window.location.href = 'https://sso6.neu.edu.vn/adfs/oauth2/logout'
            }, 4000);
        }
    };

    const logout = async (): Promise<void> => {
        localStorage.removeItem("authorizationData");
        dispatch({ type: "LOGOUT" });
    };

    const register = async (
        email: string,
        name: string,
        password: string
    ): Promise<void> => {
        const accessToken = await authApi.register({ email, name, password });
        const user = await authApi.me(accessToken);

        localStorage.setItem("accessToken", accessToken);

        dispatch({
            type: "REGISTER",
            payload: {
                user,
            },
        });
    };

    return (
        <AuthContext.Provider
            value={{
                ...state,
                platform: "JWT",
                login,
                loginAdfs,
                logout,
                register,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

AuthProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default AuthContext;

async function apiMenu() {
    try {
        let data = await menuService.GetMenu();
        // let authorizationData = localStorage.getItem("authorizationData");
        // const user = JSON.parse(authorizationData);
        // let data = await menuService.GetMenuQLGD(user?.Role != "NV" ? user?.Role : "AD");
        let arr: {
            title: string;
            items: { title: string; path: string }[];
        }[] = [];

        data.forEach((x) => {
            let lstItem = x.childMenu.map((el) => {
                return {
                    title: el.TenChucNang,
                    path: el.LienKet,
                };
            });

            let tmp = {
                title: x.TenChucNang,
                items: lstItem,
            };
            arr.push(tmp);
        });
        localStorage.setItem("AuthMenu", encrypt(JSON.stringify(arr)));
        return encrypt(JSON.stringify(arr));
    } catch (error) {
        throw error;
    }
}
function encrypt(data: string) {
    var key = "2e35f242a46d67eeb74aabc37d5e5d05";
    var datas = CryptoJS.AES.encrypt(data, key); // Encryption Part
    return datas;
}

function decrypt(data: any) {
    var key = "2e35f242a46d67eeb74aabc37d5e5d05";
    var decrypted = CryptoJS.AES.decrypt(data, key).toString(CryptoJS.enc.Utf8); // Message
    return decrypted;
}


